<template>
	<v-dialog v-model="dialog" max-width="960px" persistent transition="dialog-bottom-transition" scrollable hide-overlay>
		<v-card>
			<v-toolbar card dark color="info">
				<v-btn icon dark @click.native="closeModal(false)">
					<v-icon>close</v-icon>
				</v-btn>
				<v-toolbar-title>New Policy</v-toolbar-title>
				<v-spacer></v-spacer>
				<div v-if="selectedPolicyTemplateId !== null">
					<v-btn flat @click="onBackBtnClick"><v-icon left>chevron_left</v-icon> Back</v-btn>
					<v-btn dark class="action-btn" @click="onPolicyChosen(selectedPolicyTemplate)">Use Template</v-btn>
				</div>
			</v-toolbar>
			<v-card-text>
				<div v-if="selectedPolicyTemplateId === null">
					<h2>Choose from a Template</h2>
					<v-layout>
						<v-flex md12>
							<div class="horizontal">
								<div class="tile-structure">
									<div class="tile-structure-children">
										<div class="add-item-squircle-box" @click="onBlankPolicyChosen">
											<v-icon>add</v-icon>
										</div>
									</div>
									<div class="tile-structure-name">Blank Policy</div>
								</div>
								<div class="tile-structure">
									<div class="tile-structure-children">
										<div class="template-card" @click="onUploadFileClick">
											<div class="">
												<v-icon>mdi-cloud-upload-outline</v-icon>
											</div>
										</div>
									</div>
									<div class="tile-structure-name">Upload File</div>
								</div>
							</div>
						</v-flex>
					</v-layout>
					<v-list subheader>
						<v-list-tile v-for="policy in policyTemplates" :key="policy.id" avatar @click="onPolicyClick(policy)">
							<v-list-tile-avatar>
								<v-icon v-if="policy.contentType == 0" class="amber white--text">mdi-file-document-edit-outline</v-icon>
								<v-icon v-if="policy.contentType == 1" class="amber white--text">mdi-file-document-outline</v-icon>
							</v-list-tile-avatar>

							<v-list-tile-content>
								<v-list-tile-title>{{ policy.name }}</v-list-tile-title>
								<v-list-tile-sub-title v-if="policy.contentType == 1"><i>This template cannot be modified</i></v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action v-if="policy.geoCountryCodeISO !== null">
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<!-- <v-chip v-on="on" small>
													<v-avatar>
														<v-icon>mdi-earth</v-icon>
													</v-avatar>
													{{policy.geoCountryCodeISO[0]}}
													</v-chip>	 -->
									</template>
									<span>This template is relevant to Australia only</span>
								</v-tooltip>
							</v-list-tile-action>

							<v-list-tile-action>
								<v-icon color="grey lighten-1">chevron_right</v-icon>
							</v-list-tile-action>
						</v-list-tile>
					</v-list>
				</div>

				<div v-if="selectedPolicyTemplateId !== null">
					<v-alert type="info" :value="selectedPolicyTemplate.isSimplifiedTemplate" class="mb-3 text-xs-left">
						This HR template has been simplified for clarity and ease of understanding. It is intended as a general guide only and does not replace your legal obligations under the Fair Work Act 2009 or other applicable legislation.
						We recommend seeking professional HR or legal advice for your specific situation.
					</v-alert>
					<hr-document :hr-document="selectedPolicyTemplate" :logged-in-tenant="loggedInTenant" hide-footer is-template :is-admin="isAdmin" />
				</div>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>

		<upload-hr-document v-if="uploadFileDialog" :dialog="uploadFileDialog" :upload-errors="uploadFileDialogErrors" :is-saving="uploadFileDialogIsSaving" @onClose="uploadFileDialog = false" @onSubmit="onUploadFile" />
	</v-dialog>
</template>

<script>
	import HrDocument from '@/components/hrDocuments/HrDocument';
	import UploadHrDocument from '@/components/hrDocuments/UploadHrDocument';

	import 'flag-icon-css/css/flag-icon.css';

	export default {
		props: {
			dialog: {
				type: Boolean
			},
			policyTemplates: {
				type: Array,
				required: true
			},
			loggedInTenant: {
				type: Object,
				required: true
			},
			isAdmin: {
				type: Boolean,
				required: true
			}
		},
		components: {
			HrDocument,
			UploadHrDocument
		},
		data() {
			return {
				selectedPolicyTemplateId: null,
				uploadFileDialog: false,
				uploadFileDialogErrors: null,
				uploadFileDialogIsSaving: false
			};
		},
		computed: {
			selectedPolicyTemplate() {
				if (this.policyTemplates !== null && this.policyTemplates.length > 0 && this.selectedPolicyTemplateId !== null) {
					return this.policyTemplates.find(x => x.id === this.selectedPolicyTemplateId);
				}
				return null;
			}
		},
		methods: {
			onBlankPolicyChosen() {
				this.$emit('onBlankPolicySelected');
			},
			onPolicyChosen(policy) {
				this.$emit('onPolicySelected', policy);
			},
			onPackChosen(pack) {
				this.$emit('onPackSelected', pack);
			},
			onPolicyClick(policy) {
				this.selectedPolicyTemplateId = policy.id;
			},
			onBackBtnClick() {
				this.selectedPolicyTemplateId = null;
			},
			closeModal() {
				this.selectedPolicyTemplateId = null;
				this.$emit('closeModal');
			},
			onUploadFileClick() {
				this.uploadFileDialog = true;
			},
			onUploadFile(formData) {
				console.log(formData);
				this.uploadFileDialogIsSaving = true;

				this.$store.dispatch('hrDocuments/uploadHrDocument', formData).then(
					newHrDocument => {
						this.uploadFileDialogIsSaving = false;
						this.$router.push(`/hrDocuments/${newHrDocument.id}/`);
					},
					error => {
						this.uploadFileDialogIsSaving = false;
						this.uploadFileDialogErrors = error.response.data;
						console.error('Error uploading document');
					}
				);
			}
		}
	};
</script>

<style scoped>
	.flag-icon {
		width: 2em;
		line-height: 2em;
	}
	.horizontal {
		align-items: center;
		display: flex;
	}
	.tile-structure {
		border-radius: 30px;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
		height: 211px;
		min-width: 150px;
		padding: 15px 0;
		width: 150px;
		align-items: center;
		background: rgba(246, 248, 249, 0);
		display: flex;
		flex-flow: column;
		position: relative;
		transition-duration: 0.4s;
	}
	.tile-structure:hover:not(.disabled) {
		background: #f6f8f9;
		transform: translate3d(0, -5px, 0);
		cursor: pointer;
	}
	.tile-structure-name {
		box-sizing: border-box;
		margin-top: 10px;
		padding: 0 10px;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		color: #151b26;
		display: -webkit-box;
		font-size: 13px;
		font-weight: 500;
		line-height: 17px;
		max-height: 34px;
		overflow: hidden;
		text-align: center;
		text-overflow: ellipsis;
		width: 100%;
	}
	.tile-structure-children {
		height: 120px;
		width: 120px;
	}
	.add-item-squircle-box {
		border-radius: 20px;
		height: 100%;
		width: 100%;
		align-items: center;
		background: #fff;
		border: 2px dashed;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
		color: #9ca6af;
		display: flex;
		fill: #9ca6af;
		justify-content: center;
		position: relative;
	}

	.template-card {
		border-radius: 20px;
		height: 120px;
		width: 120px;
		align-items: center;
		background-color: #8da3a6;
		display: flex;
		flex-direction: column;
		justify-content: center;
		position: relative;
	}
	.template-card.blue {
		background-color: #4186e0;
	}
	.template-card .v-icon {
		color: #fff;
		font-size: 50px;
	}
</style>
